// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "content_type": {
      "column": {
        "default": null,
        "name": "content_type",
        "null": true,
        "type": "string"
      },
      "name": "content_type",
      "selected_by_default": null,
      "translated": null
    },
    "filename": {
      "column": {
        "default": null,
        "name": "filename",
        "null": false,
        "type": "string"
      },
      "name": "filename",
      "selected_by_default": null,
      "translated": null
    },
    "metadata": {
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      },
      "name": "metadata",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ActiveStorage::Blob",
  "collectionKey": "active_storage/blobs",
  "collectionName": "active_storage_blobs",
  "i18nKey": "active_storage/blob",
  "camelizedLower": "activeStorage::Blob",
  "name": "ActiveStorageBlob",
  "nameDasherized": "active-storage-blob",
  "pluralName": "active_storage_blobs",
  "ransackable_associations": [
    {
      "className": "Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "blob_id",
      "name": "attachments",
      "macro": "has_many",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "preview_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "preview_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "preview_image_attachment"
    },
    {
      "className": "ActiveStorage::VariantRecord",
      "collectionName": null,
      "foreignKey": "blob_id",
      "name": "variant_records",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "byte_size",
      "column": {
        "default": null,
        "name": "byte_size",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "checksum",
      "column": {
        "default": null,
        "name": "checksum",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "content_type",
      "column": {
        "default": null,
        "name": "content_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "filename",
      "column": {
        "default": null,
        "name": "filename",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "key",
      "column": {
        "default": null,
        "name": "key",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "service_name",
      "column": {
        "default": null,
        "name": "service_name",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "blob",
  "primaryKey": "id"
}

/** Frontend model for ActiveStorageBlob. */
export default class ActiveStorageBlob extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  contentType() {
    return this.readAttributeUnderscore("content_type")
  }

  /** @returns {boolean} */
  hasContentType() {
    const value = this.contentType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  filename() {
    return this.readAttributeUnderscore("filename")
  }

  /** @returns {boolean} */
  hasFilename() {
    const value = this.filename()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  metadata() {
    return this.readAttributeUnderscore("metadata")
  }

  /** @returns {boolean} */
  hasMetadata() {
    const value = this.metadata()

    return this._isPresent(value)
  }
}
